var sb = require('@sb/util')
const ajax = require('@subiz/ajax/src/ajax.js')
ajax.env.XMLHttpRequest = window.XMLHttpRequest
var config = require('@sb/config')

function findAnswer (challenge) {
	return challenge.answer
}

function jsonifyTextPlain (param, done) {
	let req = param.request
	if (req.content_type === 'text/plain' && req.body !== undefined) req.body = sb.stringify(req.body)
	done(true)
}

const apireq = ajax.
	setBaseUrl(config.ApiURL).
	setContentType('text/plain').
	beforeHook(jsonifyTextPlain).
	setParser('json').
	beforeHook(attachAccessToken)

function attachAccessToken (param, done) {
	if (store.mask) param.request = param.request.addQuery('x-user-mask', store.mask)
	return done(true)
}

var store = {}
let accid = () => store.matchUser().account_id
let uid = () => store.matchUser().id

var api = {
	setStore (sto) {
		store = sto
	},

	listConversations: _ =>
		apireq.
			addQuery('user_id', uid()).
			addQuery('integration_id', `${accid()}.subizv4.subikon`).
			get('/conversations'),
	listMessages: (cid, limit, start_id) =>
		apireq.
			addQuery('limit', limit).
			addQuery('start_id', start_id).
			get(`/conversations/${cid}/messages`),

	ajax: ajax,

	start: extraData => {
		let data = { starter_id: uid(), starter_type: 'user', integration_id: `${accid()}.subizv4.subikon` }
		sb.each(extraData, (v, k) => {
			data[k] = v
		})

		return apireq.post('/conversations', data)
	},

	sendConvoEvent: (cid, ev) => apireq.post(`/accounts/${accid()}/conversations/${cid}/events`, ev),
	markAsReceived: (cid, messageId) => apireq.post(`/conversations/${cid}/messages/${messageId}/receive`),
	markAsSeen: (cid, messageId) => apireq.post(`/conversations/${cid}/messages/${messageId}/seen`),
	getConversation: cid => apireq.get(`/conversations/${cid}`),
	sendEvent: data => apireq.post(`/users/${uid()}/events`, data),
	sendTyping: cid => apireq.post(`/conversations/${cid}/typing`),

	sendPresence: (device, is_focused) =>
		api.sendEvent({
			by: { id: uid(), device: device },
			type: 'presence_updated',
			data: { presence: { pinged: Date.now(), is_focused } },
		}),

	sendContent: (device, pageUrl, pageTitle) =>
		api.sendEvent({
			by: { id: uid(), device: device },
			type: 'content_viewed',
			data: { content: { url: pageUrl, title: pageTitle } },
		}),

	uploadToS3: async file => {
		let { body: signed, error } = await apireq.post(`/accounts/${accid()}/files`, {
			account_id: accid(),
			description: 'upload\n user-client: web-widget',
			name: file.name.replace(/\s+/g, '_'),
			size: file.size,
			type: file.type,
		})
		if (error) return { error }

		let contentType = file.type || 'application/octet-stream'
		;({ error } = await ajax.setContentType(contentType).put(signed.signed_url, file))
		if (error) return { error }

		// finish uploading
		let body
		;({ body, error } = await apireq.post(`/accounts/${accid()}/files/${signed.id}`, { account_id: accid() }))
		if (error) return { error }

		return { url: config.FileURL + '/' + body.url }
	},

	getChallenge: accid => apireq.post(`/accounts/${accid}/scrypt-challenges`),

	createUser: async accid => {
		for (var i = 0; i < 10; i++) {
			const { body: challenge } = await api.getChallenge(accid)
			const answer = findAnswer(challenge)
			const data = { challenge_id: challenge.id, answer: '' + answer }

			let { body: user, error } = await apireq.post(`/accounts/${accid}/scrypt-challenges/users`, data)
			if (error) {
				await sb.sleep(1000)
				continue
			}
			return user
		}
	},

	time: _ => apireq.get('/time'),

	updateUser: async data => {
		for (var i = 0; i < 10; i++) {
			let { body, error } = await apireq.post(`/users/${uid()}`, data)
			if (!error) return { body }

			await sb.sleep(3000)
			continue
		}
		return { error: 'error' }
	},

	getUserSetting: () => apireq.get(`/accounts/${accid()}/widgets/${uid()}`),
	updateUserSetting: setting => apireq.post(`/accounts/${accid()}/widgets/${uid()}`, setting),

	sendImpression: impression =>
		apireq.post(`/accounts/${accid()}/campaigns/${impression.campaign_id}/impressions`, impression),
	sendConversion: conversion =>
		apireq.post(`/accounts/${accid()}/campaigns/${conversion.campaign_id}/conversions`, conversion),
	setGoalReached: ucStatus =>
		apireq.post(`/accounts/${accid()}/campaigns/${ucStatus.campaign_id}/user-campaign-status`, ucStatus),
}

export default api
